const gall_observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
      }
    });
  },
  { threshold: 0.1 }
);

const hiddenPictures = document.querySelectorAll(".hide");
hiddenPictures.forEach((el) => gall_observer.observe(el));
